$('.input_minus_plus').each(function(index, el) {
	var $this = $(el),
		$input = $this.find('input'),
		$buttons = $this.find('.minus_plus'),
		step = parseInt($input.attr('step')),
		min = parseInt($input.attr('min')),
		max = parseInt($input.attr('max'));

	$buttons.on('click', function(event) {
		event.preventDefault();
		var $button = $(this),
			value = parseInt($input.val()),
			new_value;
		if ($button.hasClass('minus')) { new_value = value - step; }
		if ($button.hasClass('plus')) { new_value = value + step; }
		if (new_value >= min && new_value <= max) { $input.val(new_value); }
	});
});

$('[data-tab-selector]').on('click', function(event) {
	var $this = $(this),
		tab = $this.attr('data-tab-selector'),
		multiple = $this.hasAttr('data-tab-id') ? $this.attr('data-tab-id') : false,
		$tab = $('[data-tab="'+tab+'"]'+(multiple?'[data-tab-id="'+multiple+'"]':'')),
		$others = $('[data-tab]'+(multiple?'[data-tab-id="'+multiple+'"]':'')).not($tab);

	$tab.addClass('show').removeClass('hide');
	$others.addClass('hide').removeClass('show');
});

$('.chess_points .point .mob_cover').on('click', function(event) {
	event.preventDefault();
	var $point = $(this).closest('.point'),
		$text = $point.find('.text').first();
	$('.active[data-chess-toggle-dropdown]').trigger('click');
	$text.slideToggle(400).promise().done(function() {
		if ($point.hasClass('active')) { $point.removeClass('active'); }
		else { $point.addClass('active'); }
	});
});

$('[data-chess-toggle-dropdown]').on('click', function(event) {
	event.preventDefault();
	var $this = $(this),
	    $dropdown = $('[data-chess-dropdown="'+$this.attr('data-chess-toggle-dropdown')+'"]');

	$dropdown.slideToggle(600).promise().done(function() {
		$(this).toggleClass('active');
		if ($(this).is(':hidden')) {
			$(this).css('display', '');
			$this.removeClass('active');
		} else {
			$this.addClass('active');
		}
	});
});

$('#costumes .points .wrapper').on('click', function(event) {
	$(this).toggleClass('active');
});

$('#costumes .show_more').on('click', function(event) {
	var $points = $(this).siblings('.points');
	$points.children(':hidden').slice(0, 4).slideDown(400);
	if ($points.children().length == $points.children(':visible').length) {
		$(this).slideUp(400);
	}
});

$('#faq .question').on('click', function(event) {
	event.preventDefault();
	var $this = $(this),
	    $point = $this.closest('.point'),
	    $points = $point.closest('.points'),
	    isActive = $point.hasClass('active');

	$points.find('.answer').slideUp(400).promise().done(function() {
		$points.find('.active').removeClass('active');
	});

	if (! isActive) {
		$point.find('.answer').slideDown(400).promise().done(function() {
			$point.addClass('active');
		});
	}
});

$('.prices [data-popup-open], .programs [data-popup-open]').on('click', function(event) {
	if (! $(this).hasAttr('data-price')) { return; }
	var $this = $(this),
		$popup = $('[data-popup="'+$this.attr('data-popup-open')+'"]'),
		id = $this.closest('section').attr('id'),
		price = $this.attr('data-price');
	$popup.find('input[name="form"]').val('popup_'+id);
	$popup.find('input[name="price"]').val(price);
});
